import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { BuyerInfo, ENocMLookUp, ENocMLookupData, Mode } from "../../enocapi/entities";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { LocaleUtil } from "@eres/core";
import { populateENocMLookup } from "../../enocapi/services";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import * as ENocMApi from "../../enocapi/api";

interface Prop extends BuyerInfo {
	resetAll: boolean,
}

interface ENOCLookupState {
	LicenseIssueAuthorities: ENocMLookupData[];
}

interface State extends ENOCLookupState, BuyerInfo {
	error: { [ k: string ]: string };
}

export default class CompanyInfo extends Component<Prop, State> {
	constructor( props: Prop ) {
		super( props );
		this.state = {
			LicenseIssueAuthorities: [],
			...props,
			error: {},
		};
		this.onSearchDED = this.onSearchDED.bind( this );
	}

	componentDidUpdate( prevProps: Readonly<Prop>, prevState: Readonly<State>, snapshot?: any ) {
		if ( prevProps.resetAll !== this.props.resetAll ) {
			this.setState( {
				...this.state,
				...this.props,
			} );
		}
	}

	componentDidMount(): void {
		populateENocMLookup( ENocMLookUp.LICENSE_ISSUE_AUTHORITY, this );
	}

	render() {
		const state = this.state;
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		const isResubmit = state.mode === Mode.EDIT;
		const isView = state.mode === Mode.VIEW;
		return <React.Fragment>
			<div className="row">
				<div className="col-md-4">
					<PickerInput
						{ ...kvProp }
						required={ true }
						label={ Strings.lic_issuer_authority }
						id={ "licenseAuthority" }
						items={ state.LicenseIssueAuthorities }
						toIdentifier={ ( item: ENocMLookupData ) => item.identity + "" }
						error={ state.error.licenseAuthority }
						disabled={ isView || isResubmit }
						containerClassName="form-group field-style select-control"
						formatter={ ( item: any ) => LocaleUtil.getLocalValue( item ) }
					/>
				</div>
				<div className="col-md-4 form-group">
					<div>
						<label><span>{ Strings.trade_license_number }</span>
							<span className="asterisk">*</span>
						</label>
					</div>
					<TextInputField
						{ ...kvProp }
						id={ "tradeLicenseNumber" }
						type={ "number" }
						disabled={ isView || isResubmit }
						error={ state.error.tradeLicenseNumber }
						containerClassName={ "input-group mb-3" }
					>
						<div className="input-group-append">
							<button
								disabled={ isView || isResubmit } className="btn btn_1" type="button"
								onClick={ this.onSearchDED }>{ Strings.search }</button>
						</div>
					</TextInputField>
				</div>
			</div>
			<div className="row">
				<div className="col-md-4">
					<TextInputField
						{ ...kvProp }
						id={ "CompanyNameEn" }
						required={ true }
						label={ Strings.company_name_english }
						error={ state.error.CompanyNameEn }
						containerClassName="form-group"
						disabled={ isView }
					/>
				</div>
				<div className="col-md-4">
					<TextInputField
						{ ...kvProp }
						required={ true }
						id={ "CompanyNameAr" }
						type={ "arabic" }
						label={ Strings.company_name_arabic }
						error={ state.error.CompanyNameAr }
						containerClassName="form-group"
						disabled={ isView }
					/>
				</div>
			</div>
		</React.Fragment>;
	}

	onSearchDED = () => {
		let buyer: BuyerInfo = this.state;
		if ( buyer.tradeLicenseNumber && buyer.tradeLicenseNumber !== "" ) {
			showLoading();
			ENocMApi.getDEDLicense( buyer.tradeLicenseNumber ).then( resp => {
				hideLoading();
				this.setState( {
					CompanyNameEn: resp.name ? resp.name.englishName : undefined,
					CompanyNameAr: resp.name ? resp.name.arabicName : undefined,
				} );
			} ).catch( () => {
				hideLoading();
			} );
		}
	};

	public getBuyerInfo(): BuyerInfo {
		const buyer = this.state;
		return {
			licenseAuthority: buyer.licenseAuthority,
			tradeLicenseNumber: buyer.tradeLicenseNumber,
			CompanyNameEn: buyer.CompanyNameEn,
			CompanyNameAr: buyer.CompanyNameAr,
		} as BuyerInfo;
	}
}
